import get from 'lodash/get';

import appWrapperTypes from '../appWrapper/types';
import homepageTypes from '../homepage/types';
import types from './types';

import data from './data';

const initialState = {
  user: {
    isLoggedIn: false,
  },
  totalMembers: null,
  totalAmountFinanced: null,
  apartmentUnitsFinanced: 15000,
  ...data,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case appWrapperTypes.APP_INIT:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.data.user,
        },
      };

    case appWrapperTypes.GET_USER_DATA_SUCCEEDED:
      return {
        ...state,
        user: action.user,
      };

    case homepageTypes.GET_TOKENS_SUCCEEDED:
      return {
        ...state,
        totalMembers: action.tokens.totalMembers,
        totalPropertyValueFinanced: action.tokens.totalPropertyValueFinanced,
      };

    case types.GET_LEADERSHIP_LIST_SUCCEEDED:
      return {
        ...state,
        leadership: {
          ...state.leadership,
          items: get(action, 'data.result[0].leadership'),
        },
      };

    default:
      return {
        ...state,
      };
  }
};
